import React, { useEffect, useState } from "react";

import {
  IconBattery,
  IconCall,
  IconCamera,
  IconCore,
  IconCPU,
  IconFrontCamera,
  IconPhone,
} from "../../assets/icons";
import AdditionalDetails from "./component/AdditionalDetails";
import RelatedProducts from "./component/RelatedProducts";
import { ProductService } from "../../services/productService";
// import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { ProductColor } from "../../constants/Constants";
import NoImageAvailable from "../../assets/images/no-image-available.jpg";
import { pushRecentProductId } from "../../utils/ProductUtil";
import { ProductCategoriesEnums } from "../Products/enums/ProductsEnums";
import { Spin } from "antd";

const ProductDetailPage = () => {
  // Product detail
  const { productCategory, productSlug } = useParams();
  const [productDetail, setProductDetail] = useState(null);

  // Color
  const [selectedColor, setSelectedColor] = useState(null);
  // const [selectedStorage, setSelectedStorage] = useState(null);
  const [filteredImages, setFilteredImages] = useState(null);
  const [renderImage, setRenderImage] = useState(null);

  const fetchProductDetail = async () => {
    try {
      const response = await ProductService.getProductDetail(productSlug);
      if (!response.Data) {
        // toast.error("Lỗi lấy danh sách sản phẩm!");
        return;
      }
      setProductDetail(response.Data);
      setFilteredImages(response.Data.images);
      setRenderImage(response.Data.images[0]);
      if (response.Data._id) {
        pushRecentProductId(response.Data._id);
      }
    } catch (error) {
      // toast.error("Lỗi lấy danh sách sản phẩm!");
    } finally {
    }
  };

  useEffect(() => {
    fetchProductDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productSlug]);

  useEffect(() => {
    if (productDetail) {
      if (selectedColor) {
        setFilteredImages(
          productDetail.images.filter((image) => image.color === selectedColor)
        );
        setRenderImage(
          productDetail.images.filter(
            (image) => image.color === selectedColor
          )[0]
        );
      } else {
        setFilteredImages(productDetail.images);
        setRenderImage(productDetail.images[0]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedColor]);

  const iconDetail = (key) => {
    switch (key) {
      case "screenSize":
        return { icon: <IconPhone />, title: "Kích thước màn hình" };
      case "soc":
        return { icon: <IconCPU />, title: "SoC" };
      case "coreCount":
        return { icon: <IconCore />, title: "Số lượng Cores" };
      case "mainCamera":
        return { icon: <IconCamera />, title: "Camera chính" };
      case "frontCamera":
        return { icon: <IconFrontCamera />, title: "Camera trước" };
      case "batteryCapacity":
        return { icon: <IconBattery />, title: "Dung lượng pin" };
      default:
        return null;
    }
  };

  if (!productDetail) {
    return (
      <div className="px-4 lg:px-8 py-10 text-center text-gray-500">
        <Spin spinning={true} />
      </div>
    );
  }
  return (
    <div className="w-full h-full">
      <div className="lg:px-24 px-4 bg-white">
        {/* Breadcrumb */}
        <div className="hidden lg:flex items-center gap-2 py-8 text-gray-600 text-sm">
          <a href="/products" className="hover:underline">
            Sản phẩm
          </a>
          <span>&gt;</span>
          <a href={`/products/${productCategory}`} className="hover:underline">
            {ProductCategoriesEnums[productCategory]}
          </a>
          <span>&gt;</span>
          <span className="font-semibold text-black">{productDetail.name}</span>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-10 lg:gap-8 py-4 ">
          {/* Left: Product Images */}
          <div className="lg:col-span-5">
            <div className="flex flex-col lg:flex-row lg:items-start gap-4">
              {/* Thumbnail List */}
              <div className="flex flex-row w-full h-[6rem] lg:flex-col gap-2 lg:w-1/5 lg:h-[30rem] overflow-auto">
                {filteredImages.length > 0 ? (
                  filteredImages.map((img, index) => (
                    <img
                      key={index}
                      src={img.src}
                      alt={`Ảnh ${index}`}
                      className={`w-auto cursor-pointer border rounded-md ${
                        renderImage?.src === img.src && "border-black"
                      }`}
                      onClick={() => setRenderImage(filteredImages[index])}
                    />
                  ))
                ) : (
                  <img
                    src={NoImageAvailable}
                    alt={`Không có ảnh`}
                    className={`w-auto lg:w-full cursor-pointer border rounded-md border-black
                    `}
                  />
                )}
              </div>

              {/* Main Image */}
              <div className="flex-1 flex items-center order-first lg:order-none">
                <img
                  src={renderImage?.src || NoImageAvailable}
                  alt="Selected product"
                  className="w-full h-[20rem] lg:h-[30rem] rounded-md object-contain border"
                />
              </div>
            </div>
          </div>

          {/* Right: Product Info */}
          <div className="lg:col-span-5 flex flex-col lg:justify-between gap-4">
            <div className="flex flex-col gap-4">
              <h1 className="text-2xl lg:text-3xl font-bold">
                {productDetail.name}
              </h1>
              {/* <p className="text-xl text-red-500">{product.price}</p> */}

              {/* Select Color */}
              <div className="flex gap-4 items-center">
                <p className="font-light text-md">Màu sắc:</p>
                <div className="flex gap-2">
                  {productDetail.colors.map((color) => (
                    <div
                      key={color.id}
                      className={`relative w-8 h-8 rounded-full cursor-pointer        
                        ${
                          color.available
                            ? "opacity-100 border border-gray-300"
                            : "opacity-50"
                        }`}
                      onClick={() => {
                        if (color.available) {
                          setSelectedColor((prev) =>
                            prev === color.id ? null : color.id
                          );
                        }
                      }}
                    >
                      {/* Đường viền ngoài */}
                      {selectedColor === color.id && (
                        <div className="absolute inset-0 border-2 border-black rounded-full"></div>
                      )}

                      {/* Đường viền trắng bên trong */}
                      {selectedColor === color.id && (
                        <div className="absolute inset-[2px] border-2 border-white rounded-full"></div>
                      )}

                      {/* Màu sắc */}
                      <div
                        className="w-full h-full rounded-full"
                        style={{
                          backgroundColor:
                            ProductColor.find((c) => c.id === color.id)?.hex ||
                            "",
                        }}
                      ></div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Select Storage */}
              {productDetail.storages && productDetail.storages.length > 0 && (
                <div className="flex gap-4 mt-2">
                  {productDetail.storages.map((storage) => (
                    <div
                      key={storage.size}
                      className={`px-4 py-2 rounded-md ${
                        storage.available
                          ? // selectedStorage === storage.size
                            //   ? "bg-black text-white font-bold"
                            //   :
                            "ring-1 ring-black bg-white text-black"
                          : " bg-gray-200 text-gray-400 cursor-not-allowed"
                      }`}
                      // onClick={() =>
                      //   storage.available &&
                      //   setSelectedStorage((prev) =>
                      //     prev === storage.size ? null : storage.size
                      //   )
                      // }
                    >
                      {storage.size}
                    </div>
                  ))}
                </div>
              )}

              {/* Grid Info */}
              {productDetail.details &&
                Object.entries(productDetail.details).length > 0 && (
                  <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
                    {Object.entries(productDetail.details).map(
                      ([key, value]) => (
                        <div
                          key={key}
                          className="text-sm text-gray-600 bg-[#F4F4F4] rounded-lg px-2 py-4 flex flex-row gap-2 items-center"
                        >
                          {iconDetail(key).icon}
                          <div>
                            <p>{iconDetail(key).title}</p>
                            <p className="font-semibold">{value}</p>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}
            </div>

            {/* Action Buttons */}
            <div className="grid grid-cols-2 gap-2">
              <a
                href="https://m.me/lylyiphone"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm lg:text-md col-span-2 w-full bg-blue-600 text-white py-4 px-2 rounded-md flex justify-center items-center gap-4 font-bold"
              >
                <img
                  src={
                    "https://res.cloudinary.com/dyxwbtohw/image/upload/v1759227182/messenger-icon_l04cbq.png"
                  }
                  alt="Messenger"
                  className="w-8 h-8"
                />
                Liên hệ qua Messenger để được tư vấn
              </a>
              <a
                href="tel:0935255096"
                className="w-full bg-green-500 text-white py-4 px-2 rounded-md flex justify-center items-center gap-2 font-bold"
              >
                <IconCall className="fill-white w-6 h-6" />
                <span>0935 255 096</span>
              </a>
              <a
                href="tel:0901171404"
                className="w-full bg-yellow-500 text-white py-4 px-2 rounded-md flex justify-center items-center gap-2 font-bold"
              >
                <IconCall className="fill-white w-6 h-6" />
                <span>0901 171 404</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Additional Details */}
      <AdditionalDetails data={productDetail.additionalDetails} />

      {/* Related Products */}
      <RelatedProducts
        productIds={productDetail.relatedProducts}
        category={productDetail.category}
      />
    </div>
  );
};

export default ProductDetailPage;
